import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import { constructionAsset, constructionEquipment, constructionSafety, logisticsAsset } from '@pages/Enterprise/Solution/components/Banner/BannerImages';

export default {
  desc: 'gành xây dựng hiện đại đang tìm kiếm những phương pháp thông minh và hiệu quả hơn trong môi trường không ngừng biến đổi. Giải pháp quản lý máy móc, thiết bị nặng thông minh là một phần quan trọng trong nỗ lực này.',
  keywords: 'May móc thiết bị thông minh, quản lý máy móc thiết bị, thiết bị xây dựng, máy móc xây dựng, RTLS.',
  ogSite: 'Cách mạng hóa quản lý máy móc, thiết bị nặng: Công nghệ đột phá tại hiện trường',
  title: 'Cách mạng hóa quản lý máy móc, thiết bị nặng: Công nghệ đột phá tại hiện trường',
  ogUrl: 'https://orbro.io/vi/blog/heavyEquipment',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AK0iWDzGmkjkBoP6Xvw8I-rO2ghVp5PqT4G-TOxRZma9x_Alu5navIMlFCn09CKOn81H_Madb-IgbiyiSNy0fEz9PhBPlRbc4NuZIKYHZj06eaqjP7RSKmVw0WhGazP-pzOcpYeCHaToxFMOSXbhipZqKw3T89KUknQiF7z_dhxCgvtwJE1dL27fvS_Ux57UHXUtvl1yiQcS_SQlzL7JwSBg9NoGXqPzzLivQt203pHDtTo0FUNEkkp4ILcoK9jRwzMd6_V0_PZNuKAXYZEcdeZZ7zo7ry82rcT59_D6R41M5GU_XphFwzhYGe38An9N16es0rCgbhvoP2oa8-aOPDswbWK-EAGINoE44O4TUgmG2KRK-tcqpUsNhUu8fau_ZlH_YLSc9gGpv41zNj2Uc-JHSwC074gaimJdd3MAMZlTeDTgyOQDI7OEodIXoFmzzvplifLlBzUpkHxAbA7Chn7YpTus-ZM8OxmGBL2QQuRsApAVQLnHHxEmRZpMUMcRskj0vGevc85DiZukbBv92q6BocAt9lmrz7fCtT6UWFo0Dch3wPd-mxS_vELPx9itBdEhoGU1M0SI-urofonB6RXcgj3VODFNXvmKnUe7MbJCJmSWTz4M3S175wRj8DHoLLYOPbD0M5YJEkTmSiS4aM5mFngNyxx5szGgSIBMp-AY-lzTr1M-1JnEUuC_2oQQT88ax_eS6VXIr-KjlSj8XrAJ-2RwKEGJlCo4i8b5FABD0Vqeg5soicxR_tOy0xkq4W8F8BaEfVtapquvKNAB8zs8lmzXgLUVOYzpqyVjw9_1vvfirMHsCYZZ-J8H4Tx6dRBSoymoWsOinzjd2QV8pv9yiHvCBQMyesmVjWNFZAKUM4xkmIVR9DFmkutgA0zV6VnGwrnMpAzo94Tt1stWAxVdb4R7U7HLpwwMlga6xU5yD2ESMRa13LVj8zrE5JhRmTk8ZOBfqlkrhTNMCLU_HO5YZ3yhttXl1TgbEtmR1ojfgduZMA0WwBpellXtuyIPhMZEK8wykwfrW2i4zq3V5NosBaamzVFwAy0AIJxIuf2P9IG61SM-QSm-4I_kz-KKGUhOtJcaDI7G38qHvGLJU2Ye1AxPX9POfdnfY2RhYoBIxHWdYy9UvZZDI_dgT_NaVsDRaMMaBqYEWlmr1OHV3lBx-BaxmlKUQ_RmMGJApPB-6xN2j5L1h1vKnml06CuPUOJ9CvKGrVZCy38o_KF6O6KXXqDuCE-9wdHvE3cfjefcAv298ML2Sj2b25ugq0KbO96LKoRz61WklczBoCAouwaFpenu7xf7lCIfXVskkq8AC8UaHtC1kVooqQfyOLLxG6B1skFGcUudDX7TQY2IDywQ-213Y8BUgP1BXa0mlj2fHovr0munoE2r5VngsHXQGWnYNgAIlEGQvwqL52-7v5a2RShdVo8_4d0gV0-MHBMv0akT60cfaDBukms6Lk0hX_kk20AyF2jsLu3tPcty3RIi7VZgSOyP83n-Ax6ideyVryy31tfTJIr_vqMPpQX2rhm7iQ4PBGgopMM6PUYzqUMeL9IX3t2qA0VD_tHim2kKdE17NV9ffiDP2UmH4gdzjw=w2114-h1166',
  ogType: 'website',
  date: '2023-09-25',
  tag1: '#Maymocthietbithongminh',
  tag2: '#Quanlymaymocthietbi',
  tag3: '#Thietbixaydung',
  tag4: '#Maymocxaydung',
  text: [
    {
      head: '',
      subHead: '',
      desc: 'Ngành xây dựng hiện đại đang tìm kiếm những phương pháp thông minh và hiệu quả hơn trong môi trường không ngừng biến đổi. Giải pháp quản lý máy móc, thiết bị nặng thông minh là một phần quan trọng trong nỗ lực này. Đặc biệt, giải pháp quản lý máy móc, thiết bị nặng ứng dụng công nghệ Hệ thống định vị thời gian thực (RTLS) đang cải thiện một cách đột phá hiệu quả vận hành và an toàn tại công trường xây dựng. Trong bài viết này, chúng ta sẽ tìm hiểu chi tiết về những tác động mang tính cách mạng của công nghệ RTLS đối với việc quản lý  và những lợi ích của nó',
      dot: '',
    },
    {
      head: 'Công nghệ RTLS là gì?',
      subHead: '',
      desc: 'RTLS (Real-Time Location System) là viết tắt của Hệ thống định vị thời gian thực, là công nghệ cho phép theo dõi, giám sát và quản lý thông tin về vị trí và trạng thái chính xác của các máy móc, thiết bị nặng và tài sản theo thời gian thực. Công nghệ này được sử dụng kết hợp với nhiều kỹ thuật đa dạng như GPS, RFID (Radio-Frequency Identification), UWB (Ultra-Wideband), mạng không dây (wireless network), v.v.',
      dot: '',
    },
    {
      head: 'Lợi ích của việc quản lý máy móc, thiết bị nặng bằng RTLS',
      subHead: '',
      desc: 'Việc tích hợp công nghệ RTLS vào quản lý mang lại những lợi ích đột phá sau.',
      dot: '',
    },
    {
      head: '',
      subHead: '1. Thông tin vị trí thời gian thực',
      desc: 'Công nghệ RTLS cho phép xác định vị trí chính xác của máy móc, thiết bị nặng theo thời gian thực. Nhờ đó, có thể theo dõi vị trí hiện tại và lộ trình di chuyển của máy móc, thiết bị nặng theo thời gian thực, giúp nhanh chóng tìm thấy thiết bị cần thiết và tối ưu hóa lịch trình công việc.',
      dot: '',
    },
    {
      head: '',
      subHead: '2. Bảo vệ và quản lý máy móc, thiết bị ',
      desc: 'Máy móc, thiết bị là một trong những tài sản cốt lõi của dự án xây dựng, và việc bảo vệ, quản lý chúng là nhiệm vụ then chốt. Sử dụng RTLS giúp ngăn chặn trộm cắp máy móc, thiết bị và dự đoán lịch trình bảo trì, bảo dưỡng phòng ngừa để ngăn chặn hỏng hóc từ trước.',
      dot: '',
    },
    {
      head: '',
      subHead: '3. Tối ưu hóa lịch trình công việc',
      desc: 'Thông tin vị trí thời gian thực của máy móc, thiết bị cho phép tối ưu hóa lịch trình công việc. Việc nhanh chóng tìm và sử dụng chúng cần thiết giúp ngăn chặn sự chậm trễ trong công việc và nâng cao năng suất.',
      dot: '',
    },
    {
      head: '',
      subHead: '4. Tạo dựng môi trường làm việc an toàn',
      desc: 'Công nghệ RTLS giúp nâng cao an toàn cho người lao động. Việc chia sẻ thông tin vị trí của máy móc, thiết bị giúp người lao động phòng ngừa va chạm với thiết bị và tạo dựng một môi trường xây dựng an toàn.',
      dot: '',
    },
    {
      head: '',
      subHead: '5. Tự động hóa và nâng cao hiệu quả',
      desc: 'Công nghệ RTLS đóng vai trò lớn trong việc tự động hóa và nâng cao hiệu quả quản lý thiết bị nặng. Giám sát tình trạng máy móc, thiết bị theo thời gian thực và tự động tạo báo cáo giúp đơn giản hóa quy trình làm việc, tiết kiệm nhân lực và thời gian.',
      dot: '',
    },
    {
      head: '',
      subHead: '6. Phân tích dữ liệu và hỗ trợ ra quyết định',
      desc: 'Hệ thống RTLS tạo ra nhiều dữ liệu, và việc phân tích dữ liệu này giúp cải thiện hiệu quả của dự án xây dựng. Ví dụ, nó có thể giúp đánh giá và nâng cao tỷ lệ sử dụng máy móc, thiết bị.',
      dot: '',
    },
    {
      head: '',
      subHead: '7. Thân thiện với môi trường',
      desc: 'Quản lý hiệu quả máy móc, thiết bị giúp giảm tiêu thụ năng lượng và tiết kiệm tài nguyên. Điều này góp phần làm cho dự án xây dựng trở nên thân thiện hơn với môi trường.',
      dot: '',
    },
    {
      head: '',
      subHead: '8. Cắt giảm chi phí',
      desc: 'Sử dụng công nghệ RTLS giúp cắt giảm chi phí quản lý và bảo trì máy móc, thiết bị. Ví dụ, thực hiện hiệu quả việc bảo trì và bảo dưỡng phòng ngừa giúp giảm thiểu sự cố hỏng hóc, và sử dụng dữ liệu để đưa ra quyết định thuê hoặc mua thiết bị giúp tối ưu hóa ngân sách.',
      dot: '',
    },
    {
      head: 'Lời kết',
      subHead: '',
      desc: 'Công nghệ RTLS cung cấp giải pháp đột phá cho việc quản lý máy móc, thiết bị thông minh tại công trường xây dựng, và thông qua đó, có thể đạt được nhiều lợi ích như tối ưu hóa lịch trình công việc, bảo vệ tài sản, tạo dựng môi trường làm việc an toàn, tăng cường tính thân thiện với môi trường, và cắt giảm chi phí. Do đó, công nghệ RTLS được kỳ vọng sẽ đóng vai trò tỏa sáng trong tương lai của ngành xây dựng. Nó giúp biến đổi, phát triển hiện trường ngành xây dựng và mở ra một tương lai thông minh hơn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionEquipment.thumb,
        data: 'constructionEquipment',
        link: '/vi/enterprise/construction/equipment',
      },
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/vi/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
    ],
  },
};
